import script from "./SideTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SideTab.vue?vue&type=script&setup=true&lang=js"

import "./SideTab.vue?vue&type=style&index=0&id=9dbadd16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dbadd16"]])

export default __exports__